import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class IntroV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="intro-area">
			  <div className="container">
			    <div className="intro-area-inner-2">
			      <div className="row justify-content-center">
			        <div className="col-lg-12">
			          <div className="section-title text-center">
					  	<ScrollAnimation animateIn="fadeInDown">
							<h6 className="sub-title double-line">Excellence Meets Education</h6>
							<h1 className="title" style={{fontSize:'38px'}}> Best Training & Coaching Institute Kodambakkam, Chennai </h1>
						</ScrollAnimation>
			          </div>
			        </div>
			      </div>
			      <div className="row">
			        <div className="col-md-6" style={{margin:'auto'}}>
						<ScrollAnimation animateIn="fadeInLeft">
							<p className='introAbout'>The Madras Institute of Engineering Technology (M.I.E.T.), a unit of the Vinayaka Trust, was established in 1989. It is committed to the cause of training students to upgrade their competence with rich knowledge and help them cope with the challenges of technology. MIET renders valuable service in channelizing deserving students who are denied the privilege to pursue education in the field of their choice. Students from all over India and other foreign countries have registered here. Moreover, distance learning programs are available to encourage professionals to pursue higher studies without disturbing their normal work schedule. </p>
						</ScrollAnimation>
					</div>
					<div className="col-md-6">
						<ScrollAnimation animateIn="fadeInRight">
							<img src={publicUrl+"assets/img/website/madras-institute-of-engineering-and-technology-kodambakkam.jpg"} alt="img" className=''/>
						</ScrollAnimation>
					</div>
			      </div>
			      <div className="intro-footer bg-base">
			        <div className="row">
			          <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								<img src={publicUrl+"assets/img/website/Expert-Guidance-&-Intensive-Training.png"} alt="img" className='mediabg'/>
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Expert Guidance & Intensive Training</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
			          <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/Highly-Qualified-Staff.png"} alt="img" className='mediabg' />
						
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Highly Qualified Staff</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
							
			                  		<img src={publicUrl+"assets/img/website/Rich-Study-Materials.png"} alt="img" className='mediabg' />
						
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Rich Study Materials</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/Well-Equipped-Practical-Labs.png"} alt="img" className='mediabg' />
						
			                </div>
			                <div className="media-body align-self-center">
							<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Advanced Practical Labs</h5>
									  </ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/Placement-Guaranteed.png"} alt="img" className='mediabg' />
							
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Guaranteed Placements</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/hybrid-class.png"} alt="img" className='mediabg' />
							
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Hybrid Classes</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/Smartboard-Classrooms.png"} alt="img" className='mediabg' />
							
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Smartboard Classrooms</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/Hostel-Facility.png"} alt="img" className='mediabg' />
							
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Hostel Facility</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
					  <div className="col-md-4">
			            <div className="single-list-inner">
			              <div className="media mIntro">
			                <div className="media-left">
								
			                  		<img src={publicUrl+"assets/img/website/Transportation-Facility.png"} alt="img" className='mediabg' />
							
			                </div>
			                <div className="media-body align-self-center">
								<ScrollAnimation animateIn="fadeInUp">
			                  		<h5 className='font-sizeIntro '>Transportation Facility</h5>
								</ScrollAnimation>
			                </div>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default IntroV2